import { useState, useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import './HeroSection.css';

const fallbackImage = "/imagenes/lopez-pasto.webp";

function getPreloadedData() {
  const d = window.__HOMEPAGE_DATA__;
  if (d?.exito && d.datos?.slider?.length > 0) return d.datos.slider;
  return null;
}

export default function HeroSection() {
  const { data: slidesData } = useQuery({
    queryKey: ['heroSlides'],
    queryFn: async () => {
      const res = await fetch('/api/homepage').then(r => r.json());
      if (res.exito && res.datos.slider?.length > 0) return res.datos.slider;
      return [];
    },
    staleTime: 60 * 1000,
    placeholderData: getPreloadedData,
  });

  const slides = slidesData || [];
  const [current, setCurrent] = useState(0);
  const timerRef = useRef();

  useEffect(() => {
    if (slides.length <= 1) return;
    timerRef.current = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timerRef.current);
  }, [slides.length]);

  if (slides.length === 0) {
    return (
      <section className="portada">
        <div className="portada__image-fullwidth">
          <img src={fallbackImage} alt="Festival de musica vibrante en Colombia" width="1200" height="500" fetchPriority="high" />
        </div>
      </section>
    );
  }

  return (
    <section className="portada">
      <div className="portada__slider">
        {slides.map((slide, idx) => (
          <div
            key={idx}
            className={`portada__slide ${idx === current ? 'portada__slide--active' : ''}`}
          >
            {slide.link ? (
              <a href={slide.link}>
                <img src={slide.image_url} alt={slide.title || 'Banner'} width="1200" height="500" fetchPriority={idx === 0 ? 'high' : 'auto'} />
              </a>
            ) : (
              <img src={slide.image_url} alt={slide.title || 'Banner'} width="1200" height="500" fetchPriority={idx === 0 ? 'high' : 'auto'} />
            )}
            {(slide.title || slide.subtitle) && (
              <div className="portada__slide-overlay">
                {slide.title && <h2 className="portada__slide-title">{slide.title}</h2>}
                {slide.subtitle && <p className="portada__slide-subtitle">{slide.subtitle}</p>}
              </div>
            )}
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <div className="portada__dots">
          {slides.map((_, idx) => (
            <button
              key={idx}
              className={`portada__dot ${idx === current ? 'portada__dot--active' : ''}`}
              onClick={() => setCurrent(idx)}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
}
